import * as React from 'react';
import * as style from '../../NewbuildingItem.css';
import {
  INewbuildingFromTheBuilderSchema,
  // tslint:disable-next-line:max-line-length
} from '../../../../repositories/newbuilding-card/entities/newbuilding_from_the_builder/NewbuildingFromTheBuilderSchema';

type TUndergroundInfoProps = Pick<INewbuildingFromTheBuilderSchema, 'undergroundName' | 'undergroundColor'>;

export const UndergroundInfo: React.FC<TUndergroundInfoProps> = props => {
  const { undergroundName, undergroundColor } = props;

  if (!undergroundName) {
    return null;
  }

  return (
    <div className={style['underground']}>
      {undergroundColor && (
        <div style={{ backgroundColor: `#${undergroundColor}` }} className={style['undergroundColor']} />
      )}
      {undergroundName}
    </div>
  );
};
